import { Button, Paper, Title } from '@mantine/core';
import React, { useState } from 'react';
import dayjs from 'dayjs';
import B2BButton from '../components/common/B2BButton';
import { createB2BAPI } from '../api/Interceptor';
import { IconArrowLeft } from '@tabler/icons-react';
import { over } from 'lodash';
import DeliveryScheduleModal from './DeliveryScheduleModal';
import { useNavigate } from 'react-router-dom';
import DeliveryScheduleForm from './DeliveryScheduleForm';
import "./SalesOrderTableFuture.css"

const SalesOrderTableFuture = ({
  columns,
  data,
  Stockdata2,
  ActiveTabTop,
  purchaseOrder,
  handleSaveProduct,
  setPurchaseOrder,
  salesData,
  salesOrder,
  agentData,
  variantId,
  open,
  fromSales,
  isSalesOrder,
  title,
  buttonArr = [],
  fixedcolumns }) => {
  const B2B_API = createB2BAPI();
  const navigate = useNavigate();
  const [modelOpended, setModelOpended] = useState(false);
  const [modelOpended1, setModelOpended1] = useState(false);
  const processedColumns = columns?.map((col) => ({
    ...col,
    accessorFn: col.accessorFn || (col.accessorKey === 'sno'
      ? (_, index) => index + 1
      : undefined),
    Cell: col.formatDate
      ? ({ row }) => dayjs(row.original[col.accessorKey]).format('DD/MM/YYYY')
      : col.Cell,
  }));

  return (
    <div>
      <Paper withBorder p="md">
        <div style={{ display: "flex", justifyContent: 'space-between', backgroundColor: 'lightgray', textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
            <h3 style={{ padding: '0.5rem' }}>{title}</h3>
            {salesOrder?.customer?.gstnNo || salesData?.customer?.gstnNo && <div style={{ marginRight: '1rem' }}> GST NO : <span > {salesOrder?.customer?.gstnNo || salesData?.customer?.gstnNo}</span></div>}
          </div>
          <div style={{ display: 'flex', gap: '2rem', flexDirection: 'row-reverse', margin: '0.5rem' }}>
            {buttonArr?.map((button, idx) => (
              <B2BButton
                key={idx}
                name={button?.name}
                color={button?.color}
                variant={button?.variant}
                style={button?.style}
                onClick={button?.onClick}
                disabled={button?.disabled}
              />
            ))}

          </div>
          {(salesOrder?.orderStatus === 'NEW' || salesOrder?.orderStatus === 'CONFIRMED') &&
            <div style={{ display: 'flex', gap: '2rem', flexDirection: 'row-reverse', marginTop: '0.2rem' }}>
              {((salesOrder?.orderType !== 'SWATCH') && !fromSales) && <B2BButton style={{ background: 'green', marginLeft: '0.5rem' }} disabled={!variantId} onClick={open} name={'Allocate Stock'} />}
            </div>
          }
        </div>
        <div style={{ display: 'flex' }}>
          <table className="salestable">
            <thead>
              <tr>
                {processedColumns?.map((col) => (
                  <th key={col.accessorKey}>
                    {col.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
           {data && data.length > 0 ? (
                data.map((row, idx) => (
                  <tr key={idx}>
                  {processedColumns?.map((col) => {
                    const CellRenderer = col.Cell || col.cell;
                    const cellValue =
                      typeof CellRenderer === 'function'
                        ? CellRenderer({ row: { original: row } })
                        : row[col?.accessorKey];

                    return (
                      <td
                        key={col?.accessorKey}
                        data-label={col.header}  
                      >
                        <span>{cellValue}</span>
                         </td>
                      );
                    })}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={processedColumns.length} style={{ textAlign: "center", padding: "1rem" }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </Paper >

    </div>
  );
};

export default SalesOrderTableFuture;
